export default __webpack_public_path__ + "static/media/quantisal_step5.8282fa8d.png";